export default __webpack_public_path__ + "static/media/AHRQ-image.20709234.jpg";